import { coreDefaultTheme, DottedProgressTheme } from '@kite-js/theme';
import colors from '@theme/japanican/theme-japanican/colors';

const dottedProgressTheme: DottedProgressTheme = {
    ...coreDefaultTheme.dottedProgress!,
    dotColors: [colors.red[100], colors.red[200], colors.red[300], colors.red[400], colors.red[500]],
};

export default dottedProgressTheme;
